import { Models } from '../../models';
import { ISeoComponentProps } from './seo-component';

export const seoDataResolver = (data: IKontentItem): ISeoComponentProps => {
  return Models.SEOBoxModel.create(data as ISEOComponent);
};
